import { useEffect, useState } from "react";
import apiRequest from "../../../utils/apiClient";
import { getUsageLimitsUrl } from "../../constants";
import { UsageLimitsResponse } from "../../../types/user";

interface UseUsageLimitsResult {
  usage: UsageLimitsResponse | null;
  loadError: boolean;
}

export const useUsageLimits = (): UseUsageLimitsResult => {
  const [usage, setUsage] = useState<UsageLimitsResponse | null>(null);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setLoadError(false);
    apiRequest(getUsageLimitsUrl, { method: "GET" })
      .then(async (response) => {
        if (!response.ok) {
          setLoadError(true);
          return;
        }
        const data: UsageLimitsResponse = await response.json();
        setUsage(data);
      })
      .catch(() => setLoadError(true));
  }, []);

  return { usage, loadError };
};
